import { render, staticRenderFns } from "./KnowledgeCenter.vue?vue&type=template&id=a0b05bea&scoped=true"
import script from "./KnowledgeCenter.vue?vue&type=script&lang=js"
export * from "./KnowledgeCenter.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeCenter.vue?vue&type=style&index=0&id=a0b05bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b05bea",
  null
  
)

export default component.exports